import { PropTypes, React } from 'imports';
import { PeriodType } from 'utils/constants';
import { Comment, EntityEditForm, FormattedDate, FormattedResource, Popup, PostForm, TextInput } from 'components/common';
import DateRange from 'utils/DateRange';
import './CommentsBlock.less';


export default class CommentsBlock extends React.PureComponent {

    static get propTypes() {
        return {
            newComment: PropTypes.shape({
                Comment: PropTypes.string.isRequired,
                ReplyToCommentID: PropTypes.number
            }),
            newCommentPlaceholder: FormattedResource.resourcePropType,
            submitButton: PostForm.buttonPropType,
            cancelButton: PostForm.buttonPropType,
            comments: PropTypes.arrayOf(Comment.commentPropType).isRequired,
            isActive: PropTypes.bool,
            autofocus: PropTypes.bool,
            onNewCommentChange: PropTypes.func,
            onNewCommentSubmit: PropTypes.func,
            onNewCommentCancelReply: PropTypes.func,
            onNewCommentRetry: PropTypes.func,
            onReplyClick: PropTypes.func,
            onEditedCommentSubmit: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            newCommentPlaceholder: '',
            isActive: true
        }
    }

    state = { editedComment: null };

    _onNewCommentChange = (sender, value) => {
        this.props.onNewCommentChange(sender, value);
    };

    _onNewCommentSubmit = (sender, value) => {
        this.props.onNewCommentSubmit(sender, value);
    };

    _onNewCommentCancelReply = () => {
        this.props.onNewCommentCancelReply();
    };

    _onReplyClick = (sender, comment) => {
        this.props.onReplyClick(sender, comment);
    };

    _onNewCommentRetry = (sender, comment) => {
        this.props.onNewCommentRetry(sender, comment);
    };

    _onEditCommentClick = (comment) => {
        this.setState({ editedComment: comment });
    };

    _onEditedCommentChange = (_sender, value) => {
        this.setState({ editedComment: value });
    };

    _onEditedCommentSubmit = (_sender, value) => {
        if (this.props.onEditedCommentSubmit) {
            this.props.onEditedCommentSubmit(this, value);
        }
        this._onEditedCommentCancel();
    };

    _onEditedCommentCancel = () => {
        this.setState({ editedComment: null });
    };

    render() {
        const
            { editedComment } = this.state,
            commentsEditable = !!this.props.onEditedCommentSubmit;

        return <div className="comments-block">
            {this.props.isActive ?
                <PostForm className="control"
                    autofocus={this.props.autofocus}
                    value={this.props.newComment.Comment}
                    placeholder={this.props.newCommentPlaceholder}
                    submitButton={this.props.submitButton}
                    cancelButton={this.props.cancelButton}
                    onChange={this._onNewCommentChange}
                    onSubmit={this._onNewCommentSubmit}
                    onCancel={this._onNewCommentCancelReply} /> :
                null
            }
            <div className="list">
                {this.props.comments
                    .filter(comment => !comment.ReplyToCommentID)
                    .reverse()
                    .group(comment => +new DateRange(PeriodType.DAY, comment.DateAdded).last)
                    .map((commentGroup, index) => <div key={commentGroup[0].DateAdded} className="comment-group">
                        <div className="time-stamp">
                            <FormattedDate value={new DateRange(PeriodType.DAY, commentGroup[0].DateAdded).last} year="numeric" month="long" day="numeric" />
                        </div>
                        {commentGroup.map(comment => <div key={comment.ID} className={'thread' + (this.props.newComment && this.props.newComment.ReplyToCommentID === comment.ID ? ' replying' : '')}>
                            <Comment
                                key={comment.ID}
                                comment={comment}
                                isReplying={this.props.newComment && this.props.newComment.ReplyToCommentID === comment.ID}
                                isActionsActive={this.props.isActive}
                                onReplyClick={this._onReplyClick}
                                onCancelClick={this._onNewCommentCancelReply}
                                onRetryClick={this._onNewCommentRetry}
                                onEditClick={commentsEditable ? this._onEditCommentClick.bind(this, comment) : undefined}
                            />
                            {
                                this.props.comments
                                    .filter(replyComment => replyComment.ReplyToCommentID === comment.ID)
                                    .map(replyComment =>
                                        <Comment key={replyComment.ID}
                                            comment={replyComment}
                                            isActionsActive={this.props.isActive}
                                            onRetryClick={this._onNewCommentRetry}
                                            onEditClick={commentsEditable ? this._onEditCommentClick.bind(this, replyComment) : undefined}
                                        />
                                    )
                            }
                        </div>)
                        }
                    </div>)
                    .or(<div className="no-comments">
                        <FormattedResource resource={{ id: 'common.no_comments_yet' }} />
                    </div>)
                }
            </div>

            {
                editedComment ?
                    <Popup className="new edit-comment-modal" closeMode={Popup.CloseMode.CLOSE_BUTTON} dimmed onClose={this._onEditedCommentCancel}>
                        <EntityEditForm
                            className="new"
                            submit={{ id: 'common.save' }}
                            title={{ id: 'meeting.edit_comment' }}
                            valid={!!editedComment.Comment}
                            value={editedComment}
                            onCancel={this._onEditedCommentCancel}
                            onChange={this._onEditedCommentChange}
                            onSubmit={this._onEditedCommentSubmit}
                        >
                            <EntityEditForm.Field name={{ id: 'common.comment' }} property="Comment">
                                <TextInput autofocus multiline markdownWysiwyg />
                            </EntityEditForm.Field>
                        </EntityEditForm>
                    </Popup> :
                    null
            }
        </div>;
    }
}